export default "__VITE_ASSET__CBj4ez8s__"